var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticStyle:{"padding-left":"0"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.addBookmark(_vm.data.user_id, _vm.data.post_id)}}},[_c('i',{class:[_vm.bookmarkStatus ? 'fa fa-bookmark' : 'fa fa-bookmark-o']}),_vm._v(" Bookmark\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }